import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import { Auth } from 'aws-amplify';
import { useDispatch } from 'react-redux';
import Typography from '@mui/material/Typography';
import LeftMenuItems from '../../components/cards/statistics/LeftMenuItems';
//import { menuItems } from '../../constants';
import { getAddParticipantReferenceData } from '../../redux/participant/AddParticipant/addParticipantReferenceData';
import { getOrganizationReferenceData } from '../../redux/organization/organizationForm/organizationReferenceSlice';
import { resetInvoiceReferenceData } from '../../redux/invoices/invoiceReferenceSlice';
import { resetInvoices } from '../../redux/invoices/invoicesSlice';

import PeopleIcon from '@mui/icons-material/People';
import MedicationIcon from '@mui/icons-material/Medication';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import VerifiedIcon from '@mui/icons-material/Verified';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import ContactsIcon from '@mui/icons-material/Contacts';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AssessmentIcon from '@mui/icons-material/Assessment';
import PaidIcon from '@mui/icons-material/Paid';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ReceiptIcon from '@mui/icons-material/Receipt';
import RuleIcon from '@mui/icons-material/Rule';
import NotesIcon from '@mui/icons-material/Notes';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import { getContactByUser } from '../../components/Contact/services/contactsApi';

export const menuItemsX = [
  {
    title: 'Participant',
    url: '/participants',
    icon: <PeopleIcon />,
  },
  {
    title: 'Episode',
    url: '/episodes',
    icon: <DashboardIcon />,
  },
  {
    title: 'Activity',
    url: '/activity',
    icon: <NotesIcon />,
  },
  {
    title: 'Authorization',
    url: '/authorization',
    icon: <AdminPanelSettingsIcon />,
  },
  {
    title: 'Treatment',
    url: '/treatment',
    icon: <MedicationIcon />,
  },
  //{
  //  title: 'Reports',
  //  url: '/reports',
  //  icon: <TextSnippetIcon />,
  //},
  {
    title: 'CDCR Report',
    url: '/cdcrReport',
    icon: <AssessmentIcon />,
  },
  {
    title: 'Weekly Verification',
    url: '/weeklyVerification',
    icon: <VerifiedIcon />,
  },
  {
    title: 'Invoice',
    url: '/invoice',
    icon: <FileCopyIcon />,
  },
  //{
  //  title: 'Budget',
  //  url: '/budget',
  //  icon: <PaidIcon />,
  //},
  {
    title: 'CBP',
    url: '/cbp',
    icon: <ReceiptIcon />,
  },
  {
    title: 'Contacts',
    url: '/contacts',
    icon: <ContactsIcon />,
  },
  //{
  //  title: 'Contracts Compliance',
  //  url: '/contractsCompliance',
  //  icon: <RuleIcon />,
  //},
  {
    title: 'Organizations',
    url: '/organizations',
    icon: <AccountBalanceIcon />,
  },
];

const DashboardDefault = () => {
  const [user, setUser] = useState(null);
  const [menuItems, setMenuItems] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [user?.signInUserSession.accessToken.jwtToken]);
  
  const fetchData = async () => {
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    dispatch(getAddParticipantReferenceData(authorization));
    dispatch(getOrganizationReferenceData(authorization));
    dispatch(resetInvoiceReferenceData());
    dispatch(resetInvoices());
  };

  const STOP_REGION = process.env.REACT_APP_STOP_REGION

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then(function (user) {
        getContactByUser(user)
        .then(function (loggedInContact) {
          user.contact = loggedInContact
          let menu = [];
          menu.push(
            {
              title: 'Participants',
              url: '/participants',
              icon: <PeopleIcon />,
            }            
          );
          menu.push(
            {
              title: 'Episodes',
              url: '/episodes',
              icon: <DashboardIcon />,
            }            
          );
          menu.push(
            {
              title: 'Activities',
              url: '/activity',
              icon: <NotesIcon />,
            }            
          );
          menu.push(
            {
              title: 'Authorizations',
              url: '/authorization',
              icon: <AdminPanelSettingsIcon />,
            }            
          );
          //menu.push(
          //  {
          //    title: 'Reports',
          //    url: '/reports',
          //    icon: <TextSnippetIcon />,
          //  }            
          //);

          if (user.contact.cntDept===4 || user.contact.cntDept===1) {
            menu.push(
              {
                title: 'Treatments',
                url: '/treatment',
                icon: <MedicationIcon />,
              }            
            );
            menu.push(
              {
                title: 'CDCR Report',
                url: '/cdcrReport',
                icon: <AssessmentIcon />,
              }            
            );
            menu.push(
              {
                title: 'Verification List',
                url: '/weeklyVerification',
                icon: <VerifiedIcon />,
              }            
            );            
            menu.push(
              {
                title: 'Verifications',
                url: '/weeklyVerification/0',
                icon: <VerifiedIcon />,
              }            
            );            
            menu.push(
              {
                title: 'Providers',
                url: '/cbp',
                icon: <ReceiptIcon />,
              }            
            );
          }

          if (user.contact.cntDept===4 || user.contact.cntDept===1 || user.contact.cntDept===5) {
            menu.push(
              {
                title: 'Invoicing',
                url: '/invoice',
                icon: <FileCopyIcon />,
              }            
            );
          }

          if (user.contact.cntDept===4 || user.contact.cntDept===2) {
            menu.push(
              {
                title: 'Contacts',
                url: '/contacts',
                icon: <ContactsIcon />,
              }
            );
            menu.push(
              {
                title: 'Organizations',
                url: '/organizations',
                icon: <AccountBalanceIcon />,
              }
            );
            //menu.push(
            //  {
            //    title: 'Contracts Compliance',
            //    url: '/contractsCompliance',
            //    icon: <RuleIcon />,
            //  }
            //);
          }

          if (user.contact.cntDept===4 || user.contact.cntDept===1) {
            menu.push(
              {
                title: 'Ad Hoc Query',
                url: '/query-builder',
                icon: <QueryStatsIcon />,
              }
            );
          }

          setMenuItems(menu);

        })
        .catch(() => console.log('Not signed in'));;
        return user
      })
      .catch(() => console.log('Not signed in'));
  };

  return (
    <Grid mt={4} container spacing={4}>
      {/**
      <Grid item xs={12} mt={4} mb={1} style={{textAlign: 'center'}}>
        <Typography variant='h2'>WestCare STOP Region {STOP_REGION === '3' ? 'III' : 'I'}</Typography>
      </Grid>
      **/}
      {menuItems.map((data, index) => {
        return (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Link
              to={data.url}
              style={{ textDecoration: 'none', color: '#000000' }}
            >
              <LeftMenuItems title={data.title} icons={data.icon} />
            </Link>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default DashboardDefault;
